import { HouseholdLayout } from '@/components/layouts/HouseholdLayout.jsx';
import { RecipeForm } from '../components/RecipeForm';
import { useParams } from "react-router-dom";
import { useGetRecipeQuery, useUpdateRecipeMutation } from '../api';

export function UpdateRecipePage() {
  const { householdId, id } = useParams();
  const { isFetching, data } = useGetRecipeQuery({ householdId, id });

  const [saveRecipe, saveResult] = useUpdateRecipeMutation();

  function save(data) {
    return saveRecipe({ householdId, id, data });
  }

  return (    
    <HouseholdLayout>      
      {isFetching ? 'Loading...' : <RecipeForm title={`Update ${data.data.name}`} data={data.data} save={save} saveResult={saveResult} />}
    </HouseholdLayout>
  );
}

